<div class="upper-menu">
    <img class="logo" src="assets/images/logo_xs.svg" alt="skyforest" (click)="navigate('risk-map')">
    <div class="horizontal-separator"></div>
    <div class="menu-item" (click)="navigate('projects')"
         [ngClass]="{'active': router.url.includes('projects')}"
         matTooltip="Home Page" matTooltipPosition="right">
        <inline-svg src="home.svg" className="menu-icon"
                    hoverColor="#7F8F98"
                    activeColor="#85BBF3"

        ></inline-svg>
    </div>
    <div class="menu-item" (click)="navigate('risk-map')"
         [ngClass]="{'active': router.url.includes('risk-map')}"
    matTooltip="Risk Map" matTooltipPosition="right">
        <inline-svg src="Map.svg" className="menu-icon"
                    hoverColor="#7F8F98"
                    activeColor="#85BBF3"

        ></inline-svg>
    </div>
    <div class="menu-item" (click)="navigate('report-table')"
         [ngClass]="{'active': router.url.includes('report')}"
         matTooltip="Exposure Reports" matTooltipPosition="right">
        <inline-svg src="Reports.svg" className="menu-icon"
                    hoverColor="#7F8F98"
                    activeColor="#85BBF3"

        ></inline-svg>
    </div>
    <div class="menu-item" (click)="navigate('downloads')"
         [ngClass]="{'active': router.url.includes('downloads')}"
         matTooltip="My Downloads" matTooltipPosition="right">
        <inline-svg src="downloads.svg" className="menu-icon"
                    hoverColor="#7F8F98"
                    activeColor="#85BBF3"
        ></inline-svg>
    </div>
</div>
<div class="lower-menu">
    @if (!environment.isTesting) {
    <div class="menu-item" (click)="openUserSwap()"
         matTooltip="ChangeUser" matTooltipPosition="right">
        <inline-svg src="Shared.svg" className="menu-icon"
                    hoverColor="#7F8F98"
                    activeColor="#85BBF3"

        ></inline-svg>
    </div>
    }
    <div class="menu-item" (click)="openNotifications()"
         [ngClass]="{'active': showNotification}"
         matTooltip="Notifications" matTooltipPosition="right">
        <inline-svg src="notificatioans.svg" className="menu-icon"
                    hoverColor="#7F8F98"
                    activeColor="#85BBF3"

        ></inline-svg>
    </div>
    <div class="horizontal-separator"></div>
    <div class="menu-item" (click)="navigate('settings')"
         [ngClass]="{'active': router.url.includes('settings')}"
         matTooltip="Settings" matTooltipPosition="right">
        <inline-svg src="Settings.svg" className="menu-icon"
                    hoverColor="#7F8F98"
                    activeColor="#85BBF3"

        ></inline-svg>
    </div>
    <div class="horizontal-separator"></div>
    <div class="menu-item" (click)="logout()"
         matTooltip="Log out" matTooltipPosition="right">
        <inline-svg src="log-out.svg" className="menu-icon"
                    hoverColor="#7F8F98"
                    activeColor="#85BBF3"

        ></inline-svg>
    </div>
</div>